// ---- components/About.js ----
export function About() {
  return (
    <section id="about" className="px-6 py-20 max-w-6xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
          About Us
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
          At{" "}
          <span className="font-semibold text-blue-600 dark:text-blue-400">
            Ethos Tech Hub Limited
          </span>
          , we blend deep IT expertise with strategic business insight to
          deliver transformative software and engineering solutions. Whether for
          Fortune 500 giants or agile startups, we help navigate the digital
          journey with precision and innovation.
        </p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-lg p-8 transition-transform duration-300 hover:shadow-xl hover:-translate-y-1">
        <h3 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
          What We Stand For
        </h3>
        <p className="text-gray-700 dark:text-gray-300 mb-6">
          Our elite in-house team specializes in software engineering, product
          development, cloud architecture, and digital transformation. We're
          proud to be part of organizations that live by values such as:
        </p>
        <ul className="space-y-3 list-disc list-inside text-gray-700 dark:text-gray-300 pl-2">
          <li className="hover:text-blue-600 dark:hover:text-blue-400 transition">
            Dedication and passion for excellence
          </li>
          <li className="hover:text-blue-600 dark:hover:text-blue-400 transition">
            Integrity, diversity, and honesty
          </li>
          <li className="hover:text-blue-600 dark:hover:text-blue-400 transition">
            Sharing knowledge, achievements, and experiences
          </li>
          <li className="hover:text-blue-600 dark:hover:text-blue-400 transition">
            Caring about our colleagues and their well-being
          </li>
          <li className="hover:text-blue-600 dark:hover:text-blue-400 transition">
            Retaining top talent and fostering motivation
          </li>
        </ul>
      </div>
    </section>
  );
}
